// shared/pdf/components/PdfFilterLine.jsx
import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  wrap: { marginBottom: 8 },
  text: { fontSize: 8, fontFamily: 'NotoSans' },
});

export default function PdfFilterLine({ filters, theme }) {
  if (!filters) return null;
  return (
    <View style={styles.wrap}>
      <Text style={[styles.text, { color: theme.muted }]}>{filters}</Text>
    </View>
  );
}
